import { provideHttpClient, withXhr, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';
import { importProvidersFrom, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AssetsSharedModule, AuthInterceptor, MemoryOAuthStorage, ServiceOrigins, TranslationService } from '@assets/shared';
import { OAuthModule, OAuthStorage } from 'angular-oauth2-oidc';
import { ToastrModule } from 'ngx-toastr';

import { AppRoutingModule } from './app/app-routing.module';
import { AppComponent } from './app/app.component';
import { CoreModule } from './app/modules/core/core.module';
import { environment } from './environments/environment';

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    // No resourceServer on the OAuthModule any more. It could attach a token but never renew one,
    // which was enough while a hidden iframe kept the token fresh. AuthInterceptor does both.
    importProvidersFrom(BrowserModule, BrowserAnimationsModule, AppRoutingModule, AssetsSharedModule, CoreModule, OAuthModule.forRoot(), ToastrModule.forRoot({
      maxOpened: 10,
      newestOnTop: true,
      preventDuplicates: true,
      includeTitleDuplicates: true,
      positionClass: 'toast-top-right'
    })),
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    provideAppInitializer(() => {
      const translationService = inject(TranslationService);

      return translationService.init('de');
    }),
    // Tokens live in memory, so nothing survives a reload and no refresh token sits where a script
    // can read it. Not the library's own MemoryStorage: that one keeps the PKCE verifier in memory
    // too, and the verifier has to survive the redirect to Cardinal or no login can complete.
    { provide: OAuthStorage, useExisting: MemoryOAuthStorage },
    // The hosts the access token may be sent to -- **resource servers only**. Cardinal is not one:
    // no screen here calls an api of its, and the only requests that go there are the library's own
    // protocol ones, which set the header they need themselves.
    //
    // It was listed at first because the resourceServer option had been given both urls. That put
    // the refresh request through AuthInterceptor, where it asked for the very renewal that was
    // sending it -- see AuthenticationService.renew.
    {
      provide: ServiceOrigins,
      useValue: new ServiceOrigins([
        environment.baseUrls.assetsUrl
      ])
    },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
  ]
})
  .catch(err => console.error(err));
